module.exports = __webpack_public_path__ + "static/media/enlightme-process.74d875c1.png";